import { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import axios from "axios";
import "./style.scss"
const style={position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50vw",
    bgcolor: "background.paper",
    borderRadius: "1rem",
    backgroundColor: "#fff",
    boxShadow: 24,
    p: 4,
    color: "#000",
    height: "50vh",
    overflowY: "scroll",}

function CouponTable({ couponInfo, url }) {
  const [eods, setEods] = useState(couponInfo);
  const [page, setPage] = useState(1);
  const [selectedEodId, setSelectedEodId] = useState();
  const [barcodes,setBarcode] = useState();
  const [isShowBarcodeModal,setIsShowBarcodeModal] = useState(false);
  const pageSize = 20;
  const pagedEods = eods.slice((page - 1) * pageSize, page * pageSize);

  useEffect(async() => {
    const params = { eodId: selectedEodId };
    await axios
    .post(`${url}/coupons/getBarcode`,params)
    .then((res) => (
       setBarcode(res.data) 
    ))
    .catch((error)=>{
        console.log("Fetch error",error)
    })
  }, [selectedEodId]);

  const handleEodClick = (eodId)=>{
    setSelectedEodId(eodId);
    setIsShowBarcodeModal(true);
  }
  const handleModalClose = ()=>{
    setSelectedEodId();
    setIsShowBarcodeModal(false);  
  }

  return (
    <div>
      {eods.length > 0 ? (
        <div>
          <table>
            <thead>
              <tr>
                <th>EOD ID</th>
                <th>First Sale</th>
                <th>Barcodes</th>
                <th>Sales</th>
                <th>Submitted</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {pagedEods.map((eod) => {
                return (
                  <tr key={eod.eodId} onClick={()=>handleEodClick(eod.eodId)}>
                    <td>{eod.eodId}</td>
                    <td>{new Date(eod.firstSaleTime).toLocaleString()}</td>
                    <td>{eod.barcodeCount}</td>
                    <td>{eod.saleCount}</td>
                    <td>{new Date(eod.dateSubmitted).toLocaleDateString()}</td>
                    <td>
                      <span>
                        {eod.sentDate ? (
                          <p>
                            Coupons submitted:
                            {new Date(eod.sentDate).toLocaleDateString()}
                          </p>
                        ) : (
                          <p>Coupons not submitted</p>
                        )}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div
            className="button-group"
            style={{ justifyContent: "center", marginTop: "1rem" }}
          >
            <button
              className="btn"
              onClick={() => setPage(page - 1)}
              disabled={page === 1}
            >
              Previous
            </button>
            <span style={{ margin: "0 1rem" }}>
              Page {page} of {Math.ceil(eods.length / pageSize)}
            </span>
            <button
              className="btn"
              onClick={() => setPage(page + 1)}
              disabled={page * pageSize >= eods.length}
            >
              Next
            </button>
          </div>
        </div>
      ) : (
        <h2>No info</h2>
      )}
      <Modal open={isShowBarcodeModal}>
        <Box sx={style}>
        <button onClick={handleModalClose}>
            Close
        </button>
        </Box>
      </Modal>
    </div>
  );
}
export default CouponTable;
